import { render, staticRenderFns } from "./PdvPrePostVolume.vue?vue&type=template&id=57341c0a"
import script from "./PdvPrePostVolume.vue?vue&type=script&lang=js"
export * from "./PdvPrePostVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports